module.exports = __webpack_public_path__ + "static/publish-modal-d681ad69aedfe50b820bd12c424a1dfb.jpg";